import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from '@/components/ui/sonner';
import Navigation from '@/components/layout/Navigation';
import Footer from '@/components/layout/Footer';
import ContactPopup from '@/components/ContactPopup';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import TrademarkRegistrationPage from '@/pages/services/TrademarkRegistrationPage';
import CopyrightRegistrationPage from '@/pages/services/CopyrightRegistrationPage';
import ComprehensiveSearchPage from '@/pages/services/ComprehensiveSearchPage';
import CompanyFormationPage from '@/pages/services/CompanyFormationPage';
import AmazonBrandRegistryPage from '@/pages/services/AmazonBrandRegistryPage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';
import LandingPage from '@/pages/LandingPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Landing Page - No Navigation/Footer */}
          <Route path="/lp" element={
            <>
              <LandingPage />
              <ContactPopup />
            </>
          } />
          
          {/* Main Website Pages - With Navigation/Footer */}
          <Route path="/*" element={
            <>
              <Navigation />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services/trademark-registration" element={<TrademarkRegistrationPage />} />
                <Route path="/services/copyright-registration" element={<CopyrightRegistrationPage />} />
                <Route path="/services/comprehensive-search" element={<ComprehensiveSearchPage />} />
                <Route path="/services/company-formation" element={<CompanyFormationPage />} />
                <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistryPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsOfServicePage />} />
              </Routes>
              <Footer />
              <ContactPopup />
            </>
          } />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
